import MenuBurgerI18n from './MenuBurger.i18n.js';
import {
  Slide
} from 'vue-burger-menu'
import {
  mapGetters
} from 'vuex';

export default {

  components: {
    Slide
  },

  props: {},

  computed: {
    ...mapGetters(['user', 'cart']),
    routeName() {
      return this.$route.name
    }
  },

  data() {
    return {};
  },

  watch: {},

  methods: {

    goToCart() {
      this.$router.push({
        path: `/panier`
      })
    },
    getCartLength() {
      return this.cart.length
    },
    goToMonCompte() {
      this.$router.push({
        path: `/mon-compte`
      })
    },
    goToLoginInscription() {
      this.$router.push({
        path: `/login`
      })
    }
  },

  mounted() {},

  i18n: MenuBurgerI18n,

};